export const racksFields = [
  {
    label: "Rack",
    field: "rack_name",
    sort: "asc",
    width: 150,
  },
  {
    label: "Codigo del Rack",
    field: "rack",
    sort: "asc",
    width: 270,
  },
  {
    label: "Estado",
    field: "disponible",
    sort: null,
    width: 270,
  },
  {
    label: "Tipo de carrier",
    field: "carrierType_name",
    sort: "asc",
    width: 200,
  },
  {
    label: "Área del Rack",
    field: "rackArea",
    sort: "asc",
    width: 270,
  },
  {
    label: "Posición actual",
    field: "currentPosition",
    sort: "asc",
    width: 270,
  },
];

export const rack_status = {
  0: { name: "En uso", color: "danger" },
  1: { name: "Libre", color: "success" },
  2: { name: "Reservado", color: "warning" },
};

// P01021-143: los valores vienen tal cual del fichero "Rack Information" de RCS (importRCSMap.js) —
// no todos los códigos posibles están cubiertos, por eso el fallback al código crudo en vez de
// dejarlo en blanco. '1' y '4' son el mismo tipo de carrier (Rack) a efectos de esta instalación.
export const carrier_type = {
  1: "Rack",
  4: "Rack",
  2: "Pallet",
};
